import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=67b98488&"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=67b98488&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports